<template>
  <div class="oi-subscription-form">
    <Thanks v-if="step === 'thanks'" />
    <Error v-else-if="step === 'error'" />
    <div v-else>
      <div class="row">
        <div class="column column-100">
          <h1 class="title" v-html="labels['subscribtionTitle']"></h1>
        </div>
      </div>
      <div class="row">
        <div class="column column-100">
          <div class="message" v-html="labels['subscribtionMsg']"></div>
        </div>
      </div>
      <div class="row">
        <div class="column column-67">
          <div class="sum-input">
            <span>Ежемесячное пожертвование на сумму</span>
            <input class="sum" name="sum" v-validate="'required|min:1'" :value="sum" @input="changeSum">
            <span> ₽</span>
            <small v-show="errors.has('sum')" class="help error">{{ errors.first('sum') }}</small>
          </div>
          <Email/>
        </div>
        <div class="column column-33 control">
          <button class="button donate" v-html="labels['subscribe']" @click="donate"></button>
          <img :src="require('@/assets/card_logos.png')" />
        </div>
      </div>
      <Overlay v-if="showOverlay" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Email from '@/components/shared/Email.vue'
import Overlay from '@/components/shared/Overlay.vue'
import Thanks from '@/components/shared/Thanks.vue'
import Error from '@/components/shared/Error.vue'
import { LABELS, VALIDATION_MESSAGES } from '@/settings'

const lang = 'ru'

export default {
  components: { Email, Overlay, Thanks, Error },
  computed: mapState({
    step: state => state.step,
    showOverlay: state => (state.step === 'precheckout' || state.step === 'checkout') && state.checkoutType !== 'popup',
    terms: state => state.terms,
    sum: state => state.donation.sum,
    email: state => state.donation.email,
    labels: state => LABELS[lang]
  }),
  methods: {
    changeSum (e) {
      const prop = 'sum'
      let value = parseInt(e.target.value)
      if (parseInt(value) < 1 || isNaN(value)) {
        value = 0
      }
      const change = { prop, value }
      this.$store.commit('updateDonation', change)
    },
    donate () {
      if (!this.sum) {
        return
      }
      // TODO missing validation scope, returns true even when has errors
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('donate')
        }
      })
    }
  },
  mounted () {
    this.$validator.localize(lang, VALIDATION_MESSAGES[lang])
  }
}
</script>

<style scoped>
  .oi-subscription-form {
    position: relative;
    padding: 10px;
    background: #fff;
    border: 1px dashed #ef4e24;
    max-width: 700px;
  }
  .oi-subscription-form .title {
    font-size: 20px;
  }
  .oi-subscription-form .message {
    margin-bottom: 10px;
  }
  .oi-subscription-form .sum-input span:first-child {
    margin-right: 5px;
  }
  .oi-subscription-form .sum {
    width: 60px;
    text-align: center;
  }
  .oi-subscription-form .terms {
    margin: 0 10px;
    font-size: small;
  }
  .oi-subscription-form .control {
    text-align: center;
  }
  .oi-subscription-form .control img {
    width: 150px;
  }
  .oi-subscription-form .help.error,
  .oi-subscription-form .suggestion {
    margin: 0 0 5px;
    position: relative;
    top: -5px;
  }

  @media (max-width: 400px) {
    .oi-subscription-form .column {
      max-width: 100%!important;
    }
  }
</style>
